<template>
    <div>
        <!-- Real estate search -->
        <div class="mx-auto max-w-[1200px]">
            <div
                class="-mx-4 flex items-center rounded-full border border-gray bg-white text-sm font-medium text-black-40"
            >
                <v-lightbox maxed class="flex-1" is-authenticated>
                    <template v-slot:trigger>
                        <div class="py-4 pl-8 leading-none" slot="trigger">
                            {{
                                locationOption
                                    ? "Nadaljujte z iskanjem"
                                    : "Začnite z iskanjem"
                            }}
                        </div>
                    </template>

                    <template v-slot:head>
                        <div class="flex items-center">
                            <v-icon icon="loupe" size="5" class="mr-2"></v-icon>
                            Iskanje
                        </div>
                    </template>

                    <template v-slot:content>
                        <div class="space-y-4">
                            <v-accordion
                                :title="locationPlaceholder.custom_label"
                                icon="map-pin"
                                ref="accordionLocation"
                            >
                                <template v-slot:content>
                                    <div class="px-4 pb-8">
                                        <div
                                            class="relative flex items-center rounded-full border border-gray bg-white"
                                        >
                                            <label
                                                for="location"
                                                class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full px-8 py-4 font-medium text-black-50 hover:bg-green-10 md:px-10"
                                                v-if="
                                                    !hideLocationLabel &&
                                                    locationOption === null
                                                "
                                                @click="openLocation"
                                            >
                                                <div
                                                    class="overflow-hidden text-ellipsis whitespace-nowrap text-sm"
                                                >
                                                    <span class="text-black-78"
                                                        >Lokacija:</span
                                                    >
                                                    mesto, ulica, poštna št.
                                                </div>
                                            </label>
                                            <v-select
                                                class="w-full font-medium text-black-78"
                                                :options="locations"
                                                placeholder=""
                                                v-model="locationOption"
                                                label="custom_label"
                                                @open="onOpen"
                                                @search:focus="onFocus"
                                                @search:blur="onBlur"
                                                ref="location"
                                                id="location"
                                            >
                                                <template v-slot:no-options>
                                                    Za ta iskalni niz ni zadetkov.
                                                </template>
                                            </v-select>
                                            <input
                                                type="hidden"
                                                name="location"
                                                :value="
                                                    locationOption == null
                                                        ? ''
                                                        : locationOption.value
                                                "
                                            />
                                        </div>
                                    </div>
                                </template>
                            </v-accordion>

                            <v-accordion
                                :title="rentOrBuyPlaceholder.label"
                                :icon="rentOrBuyPlaceholder.icon"
                                ref="accordionRentOrBuy"
                            >
                                <template v-slot:content>
                                    <div class="px-4 pb-8">
                                        <div class="grid grid-cols-2 gap-5">
                                            <div
                                                v-for="(option, index) in rentOrBuyOptions"
                                                v-bind:key="'rent_or_buy' + index"
                                            >
                                                <v-form-radio
                                                    name="rent_or_buy"
                                                    :id="'rent_or_buy_' + index"
                                                    :label="option.label"
                                                    :value="option.value"
                                                    v-model="rentOrBuyValue"
                                                    :fixed-height="true"
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon
                                                            :icon="option.icon"
                                                            size="5"
                                                            class="mr-2"
                                                        ></v-icon>
                                                    </template>
                                                </v-form-radio>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-accordion>
                        </div>
                    </template>
                    <template v-slot:foot>
                        <div class="flex w-full gap-3 px-4">
                            <div class="w-1/2">
                                <button
                                    class="button button--gray w-full px-2"
                                    @click="resetSearchCriteria"
                                >
                                    <v-icon icon="reset"></v-icon>
                                    Ponastavi
                                </button>
                            </div>

                            <div class="w-1/2">
                                <a href="/isci" class="button w-full px-2">
                                    <v-icon icon="loupe"></v-icon>
                                    Iščite
                                </a>
                            </div>
                        </div>
                    </template>
                </v-lightbox>

                <a
                    href="/isci"
                    class="ml-auto mr-1.5 flex h-[38px] w-[38px] items-center justify-center rounded-full bg-green text-white"
                >
                    <v-icon icon="loupe" size="5"></v-icon>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainSearchRealEstateMobile",

    props: {
        i18n: {
            type: Object,
            required: true,
        },
        enums: {
            type: Object,
            required: true,
        },
        rentOrBuyOptions: {
            type: Object,
            required: true,
        },
        locations: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {
            openedAccordion: null,
            locationOption: null,
            hideLocationLabel: false,
            rentOrBuyValue: "miete",
        };
    },
    mounted() {
    },
    watch: {
        locationOption: {
            handler: function (val, oldVal) {
                if (val !== null) {
                    this.toggleAccordion("accordionLocation");
                    this.toggleAccordion("accordionRentOrBuy");
                }
            },
        },
        rentOrBuyValue: {
            handler: function (val, oldVal) {
                if (val !== "") {
                    this.toggleAccordion("accordionRentOrBuy");
                    this.toggleAccordion("accordionRealestateType");
                }
            },
        },
    },
    computed: {
        locationPlaceholder() {
            if (this.locationOption === null) {
                return {
                    custom_label: "Lokacija",
                };
            }

            return this.locationOption;
        },
        rentOrBuyPlaceholder() {
            if (this.rentOrBuyValue === "") {
                return {
                    label: "Prodaja ali oddaja",
                    icon: "key",
                };
            }

            return this.rentOrBuyOptions.find(
                (option) => option.value === this.rentOrBuyValue
            );
        },
    },
    methods: {
        onOpen() {
        },
        openLocation() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.location;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },

        onFocus() {
            this.hideLocationLabel = true;
        },

        onBlur() {
            this.hideLocationLabel = false;
        },

        resetSearchCriteria() {
            this.locationOption = null;
            this.rentOrBuyValue = "";
        },

        toggleAccordion(ref) {
            this.$refs[ref].toggleAccordion();
        },
    },
};
</script>
